import {
  type CloseDeviceViewEntityEvent,
  type DeviceViewEntity,
  type DeviceViewNodeEntity,
  isNodeEntity,
} from 'components/DeviceView/deviceViewTypes';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { selectPathLookupApplied } from 'components/Graph/model/selectors/graphMetadata/selectPathLookupApplied';
import { selectCanDestroyPathLookupPathInspectorNode } from 'components/Graph/model/selectors/selectCanDestroyPathLookupPathInspectorNode';
import { updatePathLookupPathInspectorNode } from '../pathLookup/updatePathLookupPathInspectorNode';

export const closeDeviceViewEntity: GraphCommandFactory<
  CloseDeviceViewEntityEvent
> = (cmdContext, dispatch) => async (command) => {
  if (selectPathLookupApplied(cmdContext.getState())) {
    const canDestroyPathLookupPathInspectorNode =
      selectCanDestroyPathLookupPathInspectorNode(cmdContext.getState());
    const followingDeviceViewEntity = cmdContext
      .getDeviceView()
      .deviceViewEntities.find(
        (entity: DeviceViewEntity): entity is DeviceViewNodeEntity =>
          isNodeEntity(entity) &&
          entity.id === command.followingDeviceViewEntityId,
      );
    const currentDeviceViewEntity = cmdContext
      .getDeviceView()
      .deviceViewEntities.find(
        (entity: DeviceViewEntity): entity is DeviceViewNodeEntity =>
          isNodeEntity(entity) &&
          entity.id === command.currentDeviceViewEntityId,
      );
    dispatch(updatePathLookupPathInspectorNode, {
      followingNodeSn:
        command.followingDeviceViewElement === 'node' &&
        followingDeviceViewEntity !== undefined
          ? followingDeviceViewEntity.sn
          : null,
      previousNodeSn:
        canDestroyPathLookupPathInspectorNode(
          command.currentDeviceViewElement,
        ) && currentDeviceViewEntity !== undefined
          ? currentDeviceViewEntity.sn
          : null,
    });
  }
};
